import React, { useRef, useState, FC } from "react";
import { Popover, Box } from "@material-ui/core";
import { DPButton } from "Components/DP";
import useStyles from "./styles";

type TopNavMenuProps = {
  disabled?: boolean;
  menuItems?: JSX.Element[];
  menuName: string;
};

const TopNavMenu: FC<TopNavMenuProps> = ({
  children,
  disabled,
  menuItems,
  menuName,
}) => {
  const [open, setOpen] = useState(false);
  const handleTogglePopover = () => setOpen(!open);
  const classes = useStyles();
  const anchorEl = useRef(null);

  return (
    <Box>
      <DPButton
        aria-controls={menuName}
        aria-haspopup
        className={classes.button}
        disabled={disabled || !menuItems || !menuItems.length}
        onClick={handleTogglePopover}
        variant="text"
      >
        {children}
        <div className={classes.anchorEl} ref={anchorEl} />
      </DPButton>
      {menuItems && (
        <Popover
          anchorEl={anchorEl.current}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          classes={{ paper: classes.paper }}
          id={menuName}
          keepMounted
          onClose={handleTogglePopover}
          open={open}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
        >
          {menuItems.map((menuItem, i) =>
            React.cloneElement(menuItem, {
              key: i,
              onClick: () => {
                if (menuItem.props.onClick) {
                  menuItem.props.onClick();
                }
                handleTogglePopover();
              },
            })
          )}
        </Popover>
      )}
    </Box>
  );
};

export default TopNavMenu;
